<template src="./MenuOption.html"></template>
<script>
import { mapActions } from "vuex";

export default {
  name: "MenuOption",
  props: {
    options: {
      required: true,
      type: Array
    },
    nameOption: {
      required: true
    }
  },
  methods: {
    ...mapActions({
      setMenuPeriod: "setMenuPeriod",
    }),

    selectedOption: function (id) {
      if (id == 'country') return;
      this.setMenuPeriod({period: id });
    },
  },
};
</script>

<style lang="scss" src="./MenuOption.scss"></style>
